import Joi from 'joi'
import errorsResolver from '../schemeUtils'
import { documentTypes } from '../../helpers/data-constants'
import moment from "moment";


const AUTHORITY_LENGTH = 400
const DOCUMENT_NUMBER_LENGTH = 40
const NOW_DATE = moment().utc().add(1, 'day').format('YYYY-MM-DD')
const YESTERDAY_DATE = moment().utc().add('days', -1).format('YYYY-MM-DD')

const documentAny = Joi.string()
  .required()
  .when('documentType', [
    { is: "Иной документ", then: Joi.required() },
    { is: "Идентификационная карта", then: Joi.required() },
    { is: "Биометрический вид на жительство (гражданство иное)", then: Joi.required() },
    { is: "Биометрический вид на жительство (без гражданства)", then: Joi.required() },
    { is: "Паспорт", then: Joi.required('') },
    { is: "Удостоверение беженца", then: Joi.required('') },
  ])
  .max(DOCUMENT_NUMBER_LENGTH)
  .pattern(new RegExp('^[a-zA-Z0-9]*$'))
  .error(errorsResolver({
    max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
    required: `Номер документа обязательное поле`,
    pattern: `Номер документа содержит некорректные символы`
  }))

const dateAny = Joi.date()
  .required()
  .iso().less(NOW_DATE)
  .error(errorsResolver({
    dateLess: `Дата выдачи должна быть не ранее сегодняшнего дня`,
    dateFormat: `Некорректная дата выдачи`
  }))


const authorityAny = Joi.string()
  .trim()
  .required()
  .max(AUTHORITY_LENGTH)
  .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.(),\\- ]*$'))
  .error(errorsResolver({
    required: 'Место выдачи обязательное поле',
    pattern: `Место выдачи содержит некорректные символы`,
    max: `Место выдачи должно быть меньше ${AUTHORITY_LENGTH} символов`
  }))


const clientDocumentScheme = Joi.object({
  index: Joi.any(),
  active: Joi.bool(),
  documentType: Joi.string()
    .required().valid(...documentTypes.residency, ...documentTypes.another)
    .error(errorsResolver({
      required: `Тип документа обязательное поле`,
      values: `Тип документа обязательное поле`
    })),
  documentNumber: Joi.alternatives().conditional('documentType', {
    switch: [{
      is: "Паспорт", then: Joi.alternatives().conditional(Joi.ref('residency'),
        {
          is: true,
          then: Joi.string()
            .required()
            .max(DOCUMENT_NUMBER_LENGTH)
            .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
            .error(errorsResolver({
              max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
              required: `Номер документа обязательное поле`,
              pattern: `Номер документа в неверном формате`
            })),
          otherwise: documentAny
        })
    }, {
      is: "Вид на жительство", then: Joi.alternatives().conditional(Joi.ref('residency'),
        {
          is: true,
          then:
            Joi.string()
              .required()
              .max(DOCUMENT_NUMBER_LENGTH)
              .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
              .error(errorsResolver({
                max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
                required: `Номер документа обязательное поле`,
                pattern: `Номер документа в неверном формате`
              })),
          otherwise: documentAny
        }),
      otherwise: documentAny
    }]
  }
  ),
  country: Joi.alternatives().conditional(Joi.object(), {
    then: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Страна обязательное поле`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        }))
    })
      .invalid(null)
      .required()
      .when('documentType', { is: "Иной документ", then: Joi.allow('') })
      .error(errorsResolver({
        invalid: `Страна обязательное поле`,
        required: `Страна обязательное поле`
      })),
    otherwise: Joi.string()
      .required()
      .invalid(null)
      .error(errorsResolver({
        invalid: `Страна обязательное поле`,
        required: `Страна обязательное поле`
      }))
  }),
  startDate: Joi.alternatives().conditional('documentType', {
    switch: [{
      is: "Паспорт", then: Joi.alternatives().conditional(Joi.ref('residency'),
        {
          is: true,
          then: Joi.date()
            .required()
            .iso().less(NOW_DATE)
            .error(errorsResolver({
              dateLess: `Дата выдачи должна быть до сегодняшнего числа`,
              dateFormat: `Некорректная дата выдачи`
            })),
          otherwise: dateAny
        })
    }, {
      is: "Вид на жительство", then: Joi.alternatives().conditional(Joi.ref('residency'),
        {
          is: true,
          then: Joi.date()
            .required()
            .iso().less(NOW_DATE)
            .error(errorsResolver({
              dateLess: `Дата выдачи должна быть до сегодняшнего числа`,
              dateFormat: `Некорректная дата выдачи`
            })),
          otherwise: dateAny
        }),
      otherwise: dateAny
    }]
  }
  ),
  endDate: Joi.date()
    .iso()
    .required()
    .greater(YESTERDAY_DATE)
    .error(errorsResolver({
      dateFormat: `Некорректный срок действия`,
      dateGreater: `Документ просрочен!`
    })),
  authority: Joi.alternatives().conditional(Joi.ref('country'), {
    is: {value: Joi.any(), label: 'Беларусь'},
    then: Joi.any(),
    otherwise: Joi.alternatives().conditional(Joi.ref('documentType'),
      {
        is: Joi.valid('Паспорт', 'Вид на жительство'),
        then: Joi.string()
          .required()
          .max(AUTHORITY_LENGTH)
          .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.(),\\- ]*$'))
          .error(errorsResolver({
            required: `Место выдачи обязательное поле`,
            pattern: `Место выдачи содержит некорректные символы`,
            max: `Место выдачи должно быть меньше ${AUTHORITY_LENGTH} символов`
          })),
        otherwise: authorityAny
      }),
  }),
  govAgency: Joi.alternatives().conditional(Joi.ref('country'), {
    is: {value: Joi.any(), label: 'Беларусь'},
    then: Joi.alternatives().conditional(Joi.ref('documentType'),
      {
        is: Joi.valid('Паспорт', 'Вид на жительство'),
        then: Joi.object({
          label: Joi.string()
            .required()
            .max(AUTHORITY_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.(),\\- ]*$'))
            .error(errorsResolver({
              pattern: `Место выдачи содержит некорректные символы`,
              required: `Место выдачи обязательное`,
              max: `Место выдачи должно быть меньше ${AUTHORITY_LENGTH} символов`
            })),
          value: Joi.number()
            .error(errorsResolver({
              number: `Должно быть число`
            }))
        })
          .invalid(null)
          .required()
          .error(errorsResolver({
            invalid: `Место выдачи обязательное поле`,
            required: `Место выдачи обязательное поле`
          })),
        otherwise: Joi.object({
          label: Joi.string()
            .required()
            .max(AUTHORITY_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.(),\\- ]*$'))
            .error(errorsResolver({
              pattern: `Место выдачи содержит некорректные символы`,
              max: `Место выдачи должно быть меньше ${AUTHORITY_LENGTH} символов`
            })),
          value: Joi.number()
            .error(errorsResolver({
              number: `Должно быть число`
            }))
        }).invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Место выдачи обязательное поле`,
                required: `Место выдачи обязательное поле`
            }))
      }),
    otherwise: Joi.any(),
  }),
  residency: Joi.bool()
})

export default clientDocumentScheme
